const AppraisalObj = () => {
	return `mutation ManagerAppraisal(
		$appraisee_id: String
		$objectives: [AppraisalInput]
	) {
		managerAppraisal(
			appraisee_id: $appraisee_id
			objectives: $objectives
		)
	}`;
}

export default AppraisalObj;
